import { render, staticRenderFns } from "./IconInformationCircleOutline.vue?vue&type=template&id=b34050a6"
import script from "./IconInformationCircleOutline.vue?vue&type=script&lang=js"
export * from "./IconInformationCircleOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports